import type { PropsWithChildren } from "react";

import type { ImageSourcePropType } from "react-native";
import { ImageBackground } from "react-native";

import { Box } from "@/ui/layout";
import { LayoutToken } from "@/ui/theme/tokens";
import { isWeb } from "@/utils/platform.util";

interface HeroImageBackgroundProps extends PropsWithChildren {
  height?: number;
  imageSource: ImageSourcePropType;
}

// on native, this is a plain ImageBackground (no rounded card, matches full-bleed hero look)
// on web, it's wrapped in a rounded/margined card
const HeroImageBackground = ({
  children,
  height,
  imageSource,
}: HeroImageBackgroundProps) => {
  if (isWeb()) {
    return (
      <Box
        borderRadius={12}
        marginHorizontal={LayoutToken.ContentPaddingHorizontal}
        marginTop={24}
        overflow="hidden"
      >
        <ImageBackground
          alt="Hero Background"
          resizeMode="stretch"
          source={imageSource}
          style={{
            height,
            justifyContent: "center",
            width: "100%",
          }}
        >
          {children}
        </ImageBackground>
      </Box>
    );
  }

  return (
    <ImageBackground
      alt="Hero Background"
      resizeMode="cover"
      source={imageSource}
    >
      {children}
    </ImageBackground>
  );
};

export { HeroImageBackground };
